var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTableView',{attrs:{"head":_vm.tableHead}},_vm._l((_vm.userGrid),function(user){return _c('UsersListItem',{key:user.id,attrs:{"user":user,"onDownloadPageData":_vm.onDownloadPageData,"subscriber":_vm.subscriber}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }